import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationStart } from '@angular/router';
import { HackyService } from '../shared/_services/hacky.service';
import { StorageService } from '../shared/_services/storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private router: Router,
    private hacky: HackyService,
    storage: StorageService) {
      this.isBrowser = storage.isBrowser;
    }

  @ViewChild('stickyDettaglio', {static: false}) stickyDettaglio: ElementRef;

  showPagine = false;
  burgerMenu = false;
  menuOpen;

  isBrowser;

  showDettaglioMobileSticky = false;
  showConfiguraDettaglioMobileSticky = false;
  aggiungCarrelloDisabledDettaglioMobileSticky = false;

  subs: Subscription[] = [];

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.hacky.hideNewsletter.emit(false);
      }
    });

    this.subs.concat([
      this.hacky.showDettaglioMobileSticky.subscribe(showDettaglioMobileSticky => this.showSticky(showDettaglioMobileSticky)),
      this.hacky.showConfiguraDettaglioMobileSticky.subscribe(showConfiguraDettaglioMobileSticky => this.showConfiguraDettaglioMobileSticky = showConfiguraDettaglioMobileSticky),
      this.hacky.aggiungCarrelloDisabledDettaglioMobileSticky.subscribe(aggiungCarrelloDisabledDettaglioMobileSticky => this.aggiungCarrelloDisabledDettaglioMobileSticky = aggiungCarrelloDisabledDettaglioMobileSticky),
    ]);

  }

  ngAfterViewInit(): void {
  }


  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  showSticky(showDettaglioMobileSticky) {
    this.showDettaglioMobileSticky = showDettaglioMobileSticky;
    if (showDettaglioMobileSticky) {
      setTimeout(() => {
        document.body.appendChild(this.stickyDettaglio.nativeElement);
      });
    }
  }


  aggiungiCarrello() {
    this.hacky.aggiungiCarrelloDettaglioMobileSticky.emit();
  }


}
